import { cloneDeep, util, isCorrectVal, isDate, lg } from 'utils';
import { MAP_LIST } from '$http';


export default {
    mixins: [],
    components: {},
    props: {},
    data() {
        return {
            opts: {},
            filterText: '',
            data2: [],
            defaultProps: {
                //children: 'children',
                label: 'Name'
            },
            dialogVisible: false
        };
    },
    computed: {

    },
    watch: {
        filterText(val) {
            this.$refs.tree2.filter(val);
        }
    },
    methods: {
        getSetting() {
            return cloneDeep({
                checkedList: []
            });
        },
        show(options) {
            this.opts = Object.assign({}, this.getSetting(), options);
            this.dialogVisible = true;
            this.data2 = cloneDeep(this.$store.state.allProvince);
            this.$nextTick(() => {
                this.$refs.tree2.setCheckedNodes(this.opts.checkedList);
            });
        },
        filterNode(value, data) {
            if (!value) return true;
            return data.Name.indexOf(value) !== -1;
        },
        handleNodeClick(value) {
            this.getManager(value)
        },
        ActionManageClose() {
            this.dialogVisible = false;
            this.filterText = "";
            this.opts = {};
            this.data2 = [];
        },
        setAllCheck() {
            this.$refs.tree2.setCheckedNodes(this.$store.state.allProvince);
        },
        setAllNoCheck() {
            this.$refs.tree2.setCheckedNodes([]);
        },
        sureFn() {
            this.$emit('getCheckedNode', this.$refs.tree2.getCheckedNodes()); // 向上派发 toggle事件
            this.dialogVisible = false;
        }
    },
    mounted() {}
};


// WEBPACK FOOTER //
// ./src/common/components/selectAreaDialog/vm.js